// DTM
import React from "react";
import styled from "styled-components";
import { connect } from "react-redux";

import CircularProgress from "@material-ui/core/CircularProgress";

import scale from "../helper/scaling";
import text from "../helper/text";
import ArticleAbstract from "./ArticleAbstract";

const Wrapper = styled.div`
  width: 1050px;
  margin: 0 calc(50% - 525px);
  float: left;
  position: relative;

  display: flex;
  flex-wrap: wrap;
  @media (max-width: 1100px) {
    width: calc(100% - 26px);
    margin: 0 13px;
  }
  @media (max-width: 700px) {
    width: calc(100% - 22px);
    margin: 0 11px;
  }
`;
const Row = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  @media (max-width: 700px) {
    flex-direction: column;
  }
`;
const Input = styled.input`
  border-radius: 5px;
  border: solid 1px ${props => (props.error ? "#dd0000" : "#ececec")};
  margin: 15px 12px;
  padding: 14px 19px 17px 19px;
  height: 19px;
  width: calc(100% - 64px);
  float: left;
  font-family: Lato;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.2px;
  color: rgba(0, 0, 0, 0.85);
  :hover {
    border-color: ${props => (props.error ? "#dd0000" : "#3949ab")};
    opacity: 0.75;
  }
  :focus {
    outline: none;
    border-color: ${props => (props.error ? "#dd0000" : "#3949ab")};
    opacity: 1;
  }
`;
const ActionButton = styled.button`
  margin: 12px;
  border: 0;
  padding: 12px 22px 14px 22px;

  border-radius: 5px;
  background-color: ${props => (props.disabled ? "#eeeeee" : "#3949ab")};

  font-family: Lato;
  font-size: 14px;
  font-weight: 900;
  font-style: normal;
  font-stretch: normal;
  line-height: 17px;
  letter-spacing: 1px;
  text-align: center;
  color: #ffffff;
  text-transform: uppercase;
  cursor: pointer;
  :focus {
    outline: none;
  }
  :hover {
    opacity: 0.9;
  }
  :active {
    opacity: 0.7;
  }
`;
const Status = styled.div`
  width: 100%;
  text-align: center;

  font-family: Lato;
  font-size: 15px;
  font-weight: normal;
  font-style: italic;
  font-stretch: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: rgba(0, 0, 0, 0.85);

  @media (max-width: 1100px) {
    font-size: ${scale(1100, 767, 15, 12, "vw")};
  }
  @media (max-width: 700px) {
    font-size: 11px;
  }
`;

class FormComponent extends ArticleAbstract {
  constructor(props) {
    super(props);
    this.state = {
      state: "initial",
      message: false
    };
  }

  handleResponse(response) {
    this.setState({
      state: response.ok ? "success" : "failure"
    });
    if (response.status === 400) {
      response.text().then(text => this.setState({ message: text }));
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    const data = new FormData(event.target);
    this.setState({ state: "submitting" });
    fetch("/contact-form-submit.php", {
      method: "POST",
      body: data
    }).then(this.handleResponse.bind(this));
  }

  handleChange(event) {
    if (event.target.type === "file") {
      const target = event.target;
      const row = target.parentNode;
      const clone = row.cloneNode(true);
      row.parentNode.insertBefore(clone, row);
      target.value = target.defaultValue;
    }
  }

  render() {
    return (
      <form onSubmit={this.handleSubmit.bind(this)}>
        <Wrapper>
          {this.props.content &&
          this.props.content.template &&
          this.props.content.template.values &&
          this.props.content.template.values.map((a, ai) => (
            <Row key={ai}>
              {a.map((f, fi) => (
                <Input
                  name={f.label}
                  placeholder={f.title}
                  key={100 * ai + fi}
                  type={f.type}
                  accept={f.type && (f.type === "file" ? "image/*,.pdf" : undefined)}
                  multiple={f.type && f.type === "file"}
                  onChange={this.handleChange.bind(this)}
                />
              ))}
            </Row>
          ))}
          <input
            type="hidden"
            name="_subject"
            value={
              this.props.content ? this.props.content.title : "Contact form"
            }
          />
          {this.state.state === "submitting" &&
            <Row>
              <CircularProgress />
            </Row>
          }
          {this.state.state === "success" &&
            <Row>
              <Status>
                {text.get(
                  this.props.translations,
                  "Your_request_has_been_submitted"
                )}
              </Status>
            </Row>
          }
          {this.state.state === "failure" &&
            <Row>
              <Status>
                {text.get(
                  this.props.translations,
                  "Your_request_could_not_be_submitted"
                )}
              </Status>
            </Row>
          }
          {this.state.state === "failure" && this.state.message &&
            <Row>
              <Status>{this.state.message}</Status>
            </Row>
          }
          {(this.state.state === "initial" || this.state.state === "failure") &&
            <Row>
              <ActionButton>
                {text.get(this.props.translations, "Submit")}
              </ActionButton>
            </Row>
          }
        </Wrapper>
      </form>
    );
  }
}

const mapStateToProps = state => {
  return {
    translations: state.translations.data
  };
};

export default connect(mapStateToProps)(FormComponent);



// WEBPACK FOOTER //
// ./src/components/FormComponent.js